import _ from 'lodash';

export default function removeLoggedBMPByIdPractice(passedLoggedBMPs, idpractice, handleChange){
	let loggedBMPs = _.cloneDeep(passedLoggedBMPs);	
	_.remove(loggedBMPs, {idpractice})
	handleChange("loggedBMPs", loggedBMPs);
}